class SubscriptionUtility extends HTMLElement {
    constructor() {
        super()
    }

    parseQuantityFromPlanName(planName) {
        if (!planName) return 1;
        
        const match = planName.match(/(\d+)\s*month/i);
        return match ? parseInt(match[1]) : 1;
    }

    async updateSubscription(line, quantity, sellingPlanId, planName = null) {
        const finalQuantity = planName ? this.parseQuantityFromPlanName(planName) : quantity;
        
        await fetch(
            `/cart/change.js?sections=${document
                .querySelector('cart-drawer')
                .getAttribute('data-section-id')}`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
                body: JSON.stringify({
                    line,
                    quantity: finalQuantity,
                    selling_plan: sellingPlanId,
                }),
            }
        ).then(async (res) => {
            const data = await res.json()
            const { dataHandler } = this.querySelector('cart-form').updateCart()
            dataHandler(data)
        })
    }
}

if (!customElements.get('subscription-utility')) {
    customElements.define("subscription-utility", SubscriptionUtility)
}